import {
  Accounts,
  BusinessOverview,
  CashBookIconNew,
  Dashboard,
  Expenses,
  HomeIcon,
  Inventory,
  POSNewIcon,
  PurchaseOrders,
  Sales,
  SellerCentralIcon,
  Setting,
  Shop,
  SidebarReportIcon,
  Transaction,
} from "../../../assets/icons/icon";
import { isDemoMode } from "../../../utils/demoEnviornment";

export const getMenuList = (I18n) => [
  { icon: <HomeIcon />, label: I18n.home, route: "UCash" },
  // { icon: <GetPaid />, label: "Get paid", route: "UCash/PendingPaymentCollection" },
  // { icon: <EarnMoney />, label: "Earn money", route: "UCash/EarnMoney" },
  { icon: <Transaction />, label: I18n.transactions, route: "UCash/AllTransaction" },
];

export const getMenuBottomList = (I18n) => [
  {
    icon: <BusinessOverview />,
    label: I18n.businessoverview,
    route: "BusinessOverview",
    relatedRoutes: [
      "ProfitAndLoss",
      "CashFlow",
      "BusinessOverviewTransactions",
      "CategorizedList",
    ],
  },
  {
    icon: <SidebarReportIcon />,
    label: I18n.reports || "Reports",
    route: "Reports",
    relatedRoutes: ["Reports"],
  },
  { icon: <Accounts />, label: I18n.accounts, route: "Accounts" },
  { icon: <CashBookIconNew />, label: I18n.cashbook || "Cash book", route: "Sales/CashBook" },
  {
    icon: <Sales />,
    label: I18n.sales,
    route: "Sales",
    children: [
      {
        label: I18n.sale_invoice,
        route: "InvoiceBook/Create",
        value: "sale_invoice",
      },
      {
        label: I18n.quick_sale,
        route: "QuickSale/QuickSaleForm",
        value: "quick_sale",
      },
    ],
  },
  { icon: <POSNewIcon />, label: I18n.sale_pos, route: "POS" },
  { icon: <Expenses />, label: I18n.expenses, route: "Expenses" },
  {
    icon: <PurchaseOrders />,
    label: I18n.purchase_order,
    route: "PurchaseOrders",
  },
  { icon: <Inventory />, label: I18n.inventory, route: "Inventory" },
  ...(!isDemoMode()
    ? [{ icon: <SellerCentralIcon />, label: I18n.seller_central, route: "Saddar" }]
    : []),
  {
    icon: <Shop />,
    label: I18n.shop,
    route: "shopWholesale",
  },
  {
    icon: <Setting />,
    label: I18n.settings,
    route: "Setting",
    children: [
      { label: I18n.profile, route: "Profile", value: "profile" },
      { label: I18n.pincode_menu_label, route: "Pincode", value: "pin_code" },
      { label: I18n.printer, route: "Printer", value: "printer" },
      { label: I18n.backup, route: "Backup", value: "backup" },
      { label: I18n.language, route: "Language", value: "language" },
      // { label: "Appearance", route: "Appearance", value: 'appearance' },
      { label: I18n.logout, route: "Logout", value: "logout" },
    ],
  },
];
